import { debounce, requestIdleCallback, viewTransition } from '@theme/utilities';

const OFFSET = 40;

export class FloatingPanelComponent extends HTMLElement {
  #updatePosition = async () => {
    if (viewTransition.current) await viewTransition.current;
    const rect = this.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    this.style.top = OFFSET + 'px';
    if (rect.right > viewportWidth) {
      const overflowAmount = rect.right - viewportWidth + OFFSET;
      this.style.left = `-${overflowAmount}px`;
    }
    if (rect.left < 0) {
      const overflowAmount = Math.abs(rect.left) + OFFSET;
      this.style.left = `${overflowAmount}px`;
    }
    this.#mutationObserver.takeRecords();
  };

  #mutationObserver = new MutationObserver(this.#updatePosition);

  #resizeListener = debounce(() => {
    const parent = this.closest('details');
    const closeOnResize = this.dataset.closeOnResize === 'true';
    if (parent instanceof HTMLDetailsElement && closeOnResize) {
      parent.open = false;
      parent.removeAttribute('open');
      this.#updatePosition();
    }
  }, 100);

  connectedCallback() {
    window.addEventListener('resize', this.#resizeListener);
    requestIdleCallback(() => {
      this.#updatePosition();
      this.#mutationObserver.observe(this, { attributes: true });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.#resizeListener);
    this.#mutationObserver.disconnect();
  }
}

if (!customElements.get('floating-panel-component')) {
  customElements.define('floating-panel-component', FloatingPanelComponent);
}

// ✅ اعتراض الكمية
(function() {
  const origFetch = window.fetch;
  window.fetch = function(url, options) {
    if (
      typeof url === 'string' &&
      url.includes('/cart/add') &&
      window.innerWidth < 900
    ) {
      const qtyInput = document.querySelector(
        '#stickyPdpPrice quantity-selector-component input[type="number"], #stickyPdpPrice .quantity-selector input[type="number"]'
      );
      if (qtyInput) {
        const qty = parseInt(qtyInput.value) || 1;
        if (options && options.body instanceof FormData) {
          options.body.set('quantity', qty);
        }
        if (options && typeof options.body === 'string') {
          try {
            const parsed = JSON.parse(options.body);
            if ('quantity' in parsed) {
              parsed.quantity = qty;
              options.body = JSON.stringify(parsed);
            }
          } catch(e) {}
        }
      }
    }
    return origFetch.call(this, url, options);
  };

  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._url = url;
    return origOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function(body) {
    if (
      this._url && this._url.includes('/cart/add') &&
      window.innerWidth < 900
    ) {
      const qtyInput = document.querySelector(
        '#stickyPdpPrice quantity-selector-component input[type="number"], #stickyPdpPrice .quantity-selector input[type="number"]'
      );
      if (qtyInput && body instanceof FormData) {
        body.set('quantity', parseInt(qtyInput.value) || 1);
      }
    }
    return origSend.call(this, body);
  };

  function syncQtyToOriginalForm() {
    if (window.innerWidth >= 900) return;
    const stickyQtyInput = document.querySelector(
      '#stickyPdpPrice quantity-selector-component input[type="number"], #stickyPdpPrice .quantity-selector input[type="number"]'
    );
    if (!stickyQtyInput) return;
    const qty = parseInt(stickyQtyInput.value) || 1;

    document.querySelectorAll(
      'form[action^="/cart/add"] input[name="quantity"], product-form input[name="quantity"]'
    ).forEach(input => {
      input.value = qty;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const form = document.querySelector('form[action^="/cart/add"]');
    if (form) {
      let hiddenQty = form.querySelector('input[name="quantity"][data-sticky]');
      if (!hiddenQty) {
        hiddenQty = document.createElement('input');
        hiddenQty.type = 'hidden';
        hiddenQty.name = 'quantity';
        hiddenQty.setAttribute('data-sticky', 'true');
        form.appendChild(hiddenQty);
      }
      hiddenQty.value = qty;
    }

    const accelerated = document.querySelector('shopify-accelerated-checkout, shopify-buy-it-now-button');
    if (accelerated) {
      accelerated.setAttribute('quantity', qty);
      accelerated.dispatchEvent(new CustomEvent('quantity-change', { bubbles: true, detail: { quantity: qty } }));
    }
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest(
      'button[name="add"], [data-type="add-to-cart-btn"], button[id*="buy"], button[data-testid*="buy"], .shopify-payment-button button, .shopify-payment-button__button'
    );
    if (btn && window.innerWidth < 900) {
      syncQtyToOriginalForm();
    }
  }, true);

})();

// ============================================================
// Sticky PDP Buy Bar
// ============================================================
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('stickyPdpBar');
  if (!stickyBar) return;

  const priceSlot   = document.getElementById('stickyPdpPrice');
  const buttonsSlot = document.getElementById('stickyPdpButtons');
  if (!priceSlot || !buttonsSlot) return;

  function getSources() {
    const w = window.innerWidth;

    if (w >= 900) {
      const box = document.querySelector('.ds-buybox');
      return {
        priceEl: box ? box.querySelector('product-price') : null,
        buttonsEl: box ? box.querySelector('.buy-buttons-block') : null,
        observeEl: box
      };
    }

    const pf = document.querySelector('product-form');
    const form = pf ? pf.querySelector('form') : document.querySelector('form[action^="/cart/add"]');
    const priceEl =
      document.querySelector('.product-information product-price') ||
      document.querySelector('product-price');

    const buttonsEl =
      (pf && pf.querySelector('.buy-buttons-block')) ||
      (form && form.querySelector('.buy-buttons-block')) ||
      document.querySelector('.buy-buttons-block');

    return { priceEl, buttonsEl, observeEl: buttonsEl };
  }

  let pricePH = null;
  let btnsPH  = null;

  function mountSticky() {
    const { priceEl, buttonsEl } = getSources();
    if (!priceEl || !buttonsEl) return;

    if (priceSlot.contains(priceEl) && buttonsSlot.contains(buttonsEl)) return;

    if (!pricePH) {
      pricePH = document.createElement('span');
      pricePH.style.display = 'none';
      priceEl.parentNode.insertBefore(pricePH, priceEl);
    }
    if (!btnsPH) {
      btnsPH = document.createElement('span');
      btnsPH.style.display = 'none';
      buttonsEl.parentNode.insertBefore(btnsPH, buttonsEl);
    }

    priceSlot.appendChild(priceEl);
    buttonsSlot.appendChild(buttonsEl);

    if (window.innerWidth < 900) {
      const qtyEl = buttonsSlot.querySelector('quantity-selector-component, .quantity-selector');
      if (qtyEl && !priceSlot.contains(qtyEl)) {
        priceSlot.appendChild(qtyEl);
      }
    }

// ✅ إصلاح زر الناقص بعد النقل
    setTimeout(() => {
      document.querySelectorAll('quantity-selector-component').forEach(comp => {
        const minusBtn = comp.querySelector('button[name="minus"]');
        const input = comp.querySelector('input[type="number"]');
        if (!minusBtn || !input) return;

        if (parseInt(input.value) > 1) minusBtn.disabled = false;

        new MutationObserver(() => {
          minusBtn.disabled = parseInt(input.value) <= parseInt(input.min || 1);
        }).observe(input, { attributes: true, attributeFilter: ['value'] });

        const plusBtn = comp.querySelector('button[name="plus"]');
        if (plusBtn) {
          plusBtn.addEventListener('click', () => {
            setTimeout(() => {
              minusBtn.disabled = parseInt(input.value) <= parseInt(input.min || 1);
            }, 150);
          });
        }

        minusBtn.addEventListener('click', () => {
          setTimeout(() => {
            minusBtn.disabled = parseInt(input.value) <= parseInt(input.min || 1);
          }, 150);
        });
      });
    }, 300);
  }

  function unmountSticky() {
    const movedPrice = priceSlot.querySelector('product-price');
    const movedBtns  = buttonsSlot.querySelector('.buy-buttons-block');

    if (pricePH && movedPrice) pricePH.parentNode.insertBefore(movedPrice, pricePH);
    if (btnsPH && movedBtns)   btnsPH.parentNode.insertBefore(movedBtns, btnsPH);
  }

  let inView = true;
  let observer = null;

  function setupObserver() {
    if (observer) observer.disconnect();
    const { observeEl } = getSources();
    if (observeEl && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(([entry]) => {
        inView = entry.isIntersecting;
        decide();
      }, { threshold: 0.1 });
      observer.observe(observeEl);
    }
  }

  const decide = () => {
    const w = window.innerWidth;

    if (w <= 899) {
      if (observer) observer.disconnect();
      mountSticky();
      stickyBar.hidden = false;
      requestAnimationFrame(() => stickyBar.classList.add('is-visible'));
      document.body.classList.add('sticky-bar-visible');
      return;
    }

    const scrolled = window.scrollY > 150;
    const shouldShow = scrolled && !inView;

    if (shouldShow) {
      mountSticky();
      stickyBar.hidden = false;
      requestAnimationFrame(() => stickyBar.classList.add('is-visible'));
      document.body.classList.add('sticky-bar-visible');
    } else {
      stickyBar.classList.remove('is-visible');
      document.body.classList.remove('sticky-bar-visible');
      setTimeout(() => {
        if (!stickyBar.classList.contains('is-visible')) {
          stickyBar.hidden = true;
          unmountSticky();
        }
      }, 300);
    }
  };

  window.addEventListener('scroll', decide, { passive: true });
  window.addEventListener('resize', () => { setupObserver(); decide(); });

  setupObserver();
  decide();
});

// ✅ تحديث CSS variable + Footer padding
function updateStickyBarHeight() {
  const inner = document.querySelector('.sticky-pdp-inner');
  const footer = document.querySelector('.dreams-footer-wrapper');

  if (inner) {
    const h = inner.offsetHeight;
    if (h > 0) {
      document.documentElement.style.setProperty('--sticky-bar-h', h + 'px');
      if (footer) {
        footer.style.paddingBottom = `calc(${h}px + env(safe-area-inset-bottom))`;
      }
    }
  } else {
    if (footer) footer.style.paddingBottom = '30px';
  }
}

window.addEventListener('scroll', updateStickyBarHeight, { passive: true });
window.addEventListener('resize', debounce(updateStickyBarHeight, 100));
setTimeout(updateStickyBarHeight, 300);

// ✅ Back to top button position
function updateBackToTopPosition() {
  const bar = document.getElementById('stickyPdpBar');
  const btn = document.querySelector('[class*="ai-back-to-top"]');
  if (!btn) return;

  const barHeight = bar ? bar.querySelector('.sticky-pdp-inner')?.offsetHeight || 0 : 0;
  btn.style.bottom = (barHeight + 20) + 'px';
}

window.addEventListener('scroll', updateBackToTopPosition, { passive: true });
window.addEventListener('resize', debounce(updateBackToTopPosition, 100));
setTimeout(updateBackToTopPosition, 300);